<template>
	<div class="newRulesDetails">
		<el-form label-width='190px' class="qcFrom editFroms contentBigBox" ref="imageFrom" :rules="rules"
			:model="imageFrom" v-loading="loading">
			<el-row>
				<el-form-item label="状态">
					<div class="exportTab marr20">
						<div class="sliderScreeningR">
							<a href="javascript:;" @click="seachTab(1)" :class="imageFrom.Enable?'active':''">启用</a>
							<a href="javascript:;" @click="seachTab(0)" :class="!imageFrom.Enable?'active':''">禁用</a>
						</div>
					</div>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="中心名称(全称)" prop="HospitalName">
					<el-input size="small" class="width300" :disabled="disabled" v-model="imageFrom.HospitalName"
						placeholder="请输入中心全称"></el-input>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="中心名称(简称)" prop="ShortName">
					<span v-if="$route.query.HospitalGuid">{{imageFrom.ShortName}}</span>
					<el-input size="small" class="width195" v-model="imageFrom.ShortName" v-else placeholder="请输入中心简称">
					</el-input>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item  v-if="$route.query.HospitalGuid" label="中心唯一编号" prop="HospitalGuid" class="onlytips">
					<el-input size="small" class="width195" v-model="imageFrom.HospitalGuid" placeholder="请输入中心唯一编号">
					</el-input>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="集团内外" prop="HospitalType">
					<el-select size="small" v-model="imageFrom.HospitalType" placeholder="请选择集团内外">
						<el-option v-for="item in [
							{ label: '未知', value: 0 },
							{ label: '集团内', value: 1 },
							{ label: '集团外', value: 2 }
						  ]" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="中心等级" prop="Level">
					<el-select size="small" v-model="imageFrom.Level" placeholder="请选择医院等级">
						<el-option v-for="item in hospitalGradeList" :key="item.id" :label="item.name" :value="item.id">
							{{item.name}}
						</el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="所属区域" prop="RegionGuid">
					<el-select size="small" v-model="imageFrom.RegionGuid" placeholder="请选择中心所属区域">
						<el-option v-for="item in regionList" :key="item.RegionGuid" :label="item.Name"
							:value="item.RegionGuid">{{item.Name}}
						</el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<el-row v-if="centerFlag">
				<el-col :span="18">
					<el-form-item label="中心管理员" prop="UserGuid">
						<el-select size="small" class="roleRadius" @change="$forceUpdate()" v-model="UserName"
							multiple filterable remote reserve-keyword :remote-method="remoteMethod" style="width:240px"
							placeholder="请选择中心管理员">
							<el-option v-for="item in userList" :key="item.UserGuid" :label="item.Name"
								:value="item.UserGuid">
								<span>{{item.Name}}</span>
								<span class="rt">{{item.LoginId}}</span>
							</el-option>
						</el-select>
						<el-button type="primary" class="marl10" size="mini" @click="addRegion()">添加</el-button>
						<el-table class="qcTable mart10" :data="hospitalUsersList" max-height="130">
							<el-table-column prop="Name" label="姓名" min-width="100"></el-table-column>
							<el-table-column prop="Mobile" label="手机号" min-width="100"></el-table-column>
							<el-table-column prop="" label="操作" width="180">
								<template slot-scope="scope">
									<span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-form-item label="抽样方式 (每位医生)">
					<el-radio v-model="imageFrom.Type" v-for="item in detailsRulesParameter.TypeValue" :key="item.value"
						:label="item.value">{{item.text}}
					</el-radio>
					<input class="ratioInput" type="number" v-model.number="imageFrom.TypeValue" min="0">
					<span v-if="imageFrom.Type == 1" class="ratioSpan"> %</span>
					<span v-if="imageFrom.Type == 2" class="ratioSpan"> 例</span>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="报告阴阳性占比 (阴性:阳性)">
					<input class="ratioInput" type="number" v-model.number="imageFrom.Negative" @blur="changeAttributes('Negative')" placeholder="阴性" min="0" max="10">
					 : 
					<input class="ratioInput" type="number" v-model.number="imageFrom.Positive" @blur="changeAttributes('Positive')" placeholder="阴性" min="0" max="10">
					<span class="tips"> tips:请输入0～10的整数</span>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item>
					<el-button type="primary" class="mart40" @click="onSubmit">保存</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import Api from '../../../api'
	import axios from '@/js/api'
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				userList: [],
				regionList: [],
				selectloading: false,
				disabled: false,
				centerFlag:false,
				UserName:[],
				imageFrom: {
					"HospitalGuid": "",
					"HospitalName": "",
					"Address": "",
					"Telephone": "",
					"QCReportUrl": "",
					"Enable": 1,
					"IsDeleted": false,
					"HospitalGroup": "",
					"UserGuid": "",
					"UserName":[],
					"RegionGuid": "",
					"Level": 0,
					"Type": 1,
					"TypeValue": 0,
					"Negative":'',
					"Positive":''
				},
				rules: {
					HospitalName: [{
						required: true,
						message: '请填写中心全称',
						trigger: 'blur'
					}],
					ShortName: [{
						required: true,
						message: '请输入中心简称',
						trigger: 'blur'
					}],
				},

			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading', 'hospitalGradeList', 'detailsRulesParameter', 'hospitalUsersList'])
		},
		activated() {
			axios.ajaxGet('get', Api.api.manager.GetAllRegions).then(res => {
				this.regionList = res.data.Regions
			})
			this.clearimageFrom();
			if (this.$route.query.HospitalGuid) {
				this.centerFlag = true;
				this.setLoading(true);
				axios.ajaxGet('get', Api.api.manager.GetOneHospital, {
					HospitalGuid: this.$route.query.HospitalGuid
				}).then(res => {
					this.setLoading(false);
					this.imageFrom = res.data.Hospital;
					this.disabled = true;
				})
			}else{
				this.centerFlag = false;
			}
			this.getHospitalUsers();
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setLoading']),
			...Vuex.mapActions('breadcrumb', ['GetHospitalUsers', 'AddHospitalUser', 'DeleteHospitalUser']),
			changeAttributes(type){
				if (type == 'Negative') {
					this.imageFrom.Positive = 10 - this.imageFrom.Negative;
				}else{
					this.imageFrom.Negative = 10 - this.imageFrom.Positive;
				}
			},
			delterClick(row) {
				let _this = this;
				this.$confirm('确定删除该中心管理员吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.DeleteHospitalUser({
						"HospitalGuid": this.$route.query.HospitalGuid,
						"UserGuids": [row.UserGuid]
					}).then(res => {
						this.getHospitalUsers();
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			getHospitalUsers() {
				this.GetHospitalUsers({
					hospitalGuid: this.$route.query.HospitalGuid
				})
			},
			addRegion(list) {
				let _this = this;
				this.AddHospitalUser({
					"HospitalGuid": this.$route.query.HospitalGuid,
					"UserGuids": this.UserName
				}).then(res => {
					this.getHospitalUsers();
				})
			},
			clearimageFrom() {
				this.disabled = false;
				this.imageFrom = {
					"HospitalGuid": "",
					"HospitalName": "",
					"Address": "",
					"Telephone": "",
					"QCReportUrl": "",
					"Enable": 1,
					"IsDeleted": false,
					"HospitalGroup": "",
					"UserGuid": "",
					"RegionGuid": "",
					"Level": 0,
					"Type": 1,
					"TypeValue": 0
				}
			},
			setUserName(UserGuid) {
				let _this = this;
				_this.imageFrom.UserGuid = UserGuid;
				this.userList.forEach((item) => {
					if (item.UserGuid == UserGuid) {
						_this.imageFrom.UserName = item.Name;
					}
				})
			},
			// 启用禁用
			seachTab(type) {
				this.imageFrom.Enable = type;
			},
			// 中心管理员
			remoteMethod(query) {
				if (query !== '') {
					this.selectloading = true;
					// 获取医生列表
					axios.ajaxGet('get', Api.api.user.GetList, {
						keyword: query,
						pageIndex: 1,
						pageCount: 999999
					}).then(res => {
						this.selectloading = false;
						this.userList = res.data.Users;
					})
				} else {
					this.userList = [];
				}
			},
			// 提交
			onSubmit(formName) {
				this.$refs.imageFrom.validate((valid) => {
					if (valid) {
						this.setLoading(true);
						axios.ajaxPost('post', Api.api.manager.CreateOrUpdateHospital, this.imageFrom).then(
						res => {
							this.setLoading(false);
							if (res.data.StatusCode == 200) {
								this.$router.push('/home/manager/plan/imageCore')
							}
						})
					} else {
						return false;
					}
				});
			},
		}

	}
</script>
<style lang="scss" scoped="scoped">
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
	.tips{
		margin-left: 10px;
		font-size: 12px;
		display: inline-block;
		transform: scale(0.9);
	}
	.editFroms .el-radio {
		margin-right: 20px;
	}

	.editFroms .ratioInput {
		background: #3d4049 !important;
		border-radius: 6px;
	}

	.el-input.is-disabled>>>.el-input__inner {
		background-color: #3d4049;
		color: #ffffff;
	}

	.editFroms>>>.el-tag.el-tag--info {
		@include bg-color(titleBg);
	}
.onlytips{
	position: relative;
	&:after{
		content: '提示：请慎重修改，以防修改错误后报告同步失败';
		position: absolute;
		margin-left: 10px;
		font-size: 12px;
		display: inline-block;
		transform: scale(0.9);
		left: 377px;
		color: #f76d6d;
		top: 9px;
	}
}
</style>
